import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcSearch32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m13 3a9.99 9.99 0 0 1 10 10 9.912 9.912 0 0 1 -2.25 6.313l7.969 7.968c.187.188.281.469.281.719 0 .594-.438 1-1 1-.25 0-.5-.063-.719-.281l-7.968-7.969a9.912 9.912 0 0 1 -6.313 2.25 9.99 9.99 0 0 1 -10-10 9.99 9.99 0 0 1 10-10zm0 2c-4.406 0-8 3.594-8 8s3.594 8 8 8 8-3.594 8-8-3.594-8-8-8z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcSearch32;
